import React, { useState } from 'react';
import { BgContainer, Overlay } from './StorageStatusContainer.styled';
import StorageStatus from '../StorageStatus';
import TextView from '../../TextView';
import CleanupModal from '../CleanupModal';
import DeleteFileModal from '../DeleteFileModal';
import YellowCloud from '../../../assets/images/warning-cloud.svg';

const StorageStatusContainer = ({ storageUsed, storagePercent, totalStorage, showTitle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <BgContainer>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
          {showTitle && <TextView variant="title" style={{ color: '#123051' }}>
            Usage
          </TextView>}
        </div>
        <div style={{ width: '100%', cursor: 'pointer' }}>
          <StorageStatus storageUsed={storageUsed} storagePercent={storagePercent} totalStorage={totalStorage} />
        </div>
      </BgContainer>
    </>
  );
};

export default StorageStatusContainer;
